// The layouts that switch today's section types to their v2 component (src/sections/index.js V2_REFRESH). Pure, so
// utils/headingLevels.js can tell which component a section uses without importing Vue files.
export const V2_REFRESH_LAYOUTS = {
    cta: ["band", "card"],
    contact: ["form", "form-details"],
    faq: ["list", "open"],
    links: ["list", "cards"],
    download: ["list"],
    areas: ["list", "map"],
};
